<template>
  <div><h1>Variants</h1></div>
</template>
